/**
 * Imports
 */
import 'bootstrap'
import 'bootstrap-datepicker'
import 'bootstrap-timepicker'
import 'parsleyjs'
import './lib/parsley.locale.de.js'
import Rellax from 'rellax'
import 'owl.carousel'
import './lib/owl.linked'
import 'scrollit'
import AOS from 'aos'
import 'aos/src/sass/aos.scss'
import 'lazysizes/plugins/respimg/ls.respimg.min'
import 'lazysizes'
import 'datatables.net-bs4'

/**
 * Simple Mobile detection
 */
let is_mobile = false

if (/Mobi/.test(navigator.userAgent)) {
    is_mobile = true
    document.body.classList.add('mobile-browser');
} else {
    document.body.classList.add('desktop-browser');
}

/**
 * Bootstrap MegaMenu
 */
/*
$(document).ready(function() {
    $(".navbar .dropdown-toggle").hover(function () {
        $(this).parent().toggleClass("show");
        $(this).parent().find(".dropdown-menu").toggleClass("show");
    });

    $( ".navbar .dropdown-menu" ).mouseleave(function() {
        $(this).delay(1000).removeClass("show");
    });
});
*/

$(document).ready(function(){
    $(".dropdown").hover(
        function() {
            $('.dropdown-menu', this).stop( true, true ).slideDown("fast");
            $(this).toggleClass('open show');
            $(this).parent().toggleClass('show');
        },
        function() {
            $('.dropdown-menu', this).stop( true, true ).slideUp("fast");
            $(this).toggleClass('open show');
            $(this).parent().toggleClass('show');
        });
});
/**
 * Offcanvas Nav Trigger
 */
$(function () {
    $(".navbar-nav").clone().prependTo(".offcanvas-nav");
});

$('#offcanvas-trigger').on('click', function (e) {
    $('.scroll-pagination').toggleClass("open");
    $('.offcanvas-wrapper').toggleClass("open");
    $('body').toggleClass("offcanvas--open");
    $('.offcanvas-backdrop').fadeToggle();
    e.preventDefault();
});

/**
 * Bootstrap Forms
 */

/**
 * Bootstrap Forms - additional Elements Date / Time
 */
$('.input-group.date').datepicker({});

/**
 * Bootstrap Forms - Validation routine
 */
import 'parsleyjs'
import './lib/parsley.locale.de.js'
$(document).ready(function() {
    $("#form-validate").parsley({
        errorClass: 'is-invalid text-danger',
        successClass: 'is-valid', // Comment this option if you don't want the field to become green when valid. Recommended in Google material design to prevent too many hints for user experience. Only report when a field is wrong.
        errorsWrapper: '<span class="invalid-feedback text-danger"></span>',
        errorTemplate: '<span></span>',
        trigger: 'input'
    });

    $(".validate").parsley({
        errorClass: 'is-invalid text-danger',
        successClass: 'is-valid', // Comment this option if you don't want the field to become green when valid. Recommended in Google material design to prevent too many hints for user experience. Only report when a field is wrong.
        errorsWrapper: '<span class="invalid-feedback text-danger"></span>',
        errorTemplate: '<span></span>',
        trigger: 'input'
    });
});

(function() {
    'use strict';
    window.addEventListener('load', function() {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        let forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        let validation = Array.prototype.filter.call(forms, function(form) {
            form.setAttribute('novalidate', '');
            form.addEventListener('submit', function(event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();

/**
 * Bootstrap Forms - Trigger Modal window if present
 */
$(document).ready(function() {

    let successModal = $('#formModal');

    if (successModal) {
        $(successModal).modal('show');
    }
});


/**
 * Parallax
 */
window.addEventListener('load', () => {
    if (document.getElementsByClassName('parallax').length != 0) {
        let rellax = new Rellax('.parallax', {
            center: true,
            wrapper: document.querySelector('.teaser')
        })
    }
})

/**
 * Owl Carousel 2
 * incl. Owl.Linked Plugin (look in ./lib folder)
 */
$(document).ready(function () {

  let slidesToShow = 5;


  let navSlider = $(".nav-slider");
  let productSlider = $(".product-slider");
  let headerSlider = $(".header-slider");


    /*
    * Add data-attributes to each slide so we can go.to on click afterwards
    */
    $(navSlider).children().each(function (index) {
        $(this).attr('data-position', index);
    });

    /*
    * center the selected Slide on click
    */
    $(document).on('click', '.nav-slider .owl-item>div', function() {
        $(navSlider).trigger('to.owl.carousel', $(this).data( 'position' ) );
    });

    /*
    * Initialize synced Sliders W4.Products:SliderCategory
    */
    $(productSlider).owlCarousel({
        nav: false,
        dots: false,
        loop: false,
        items: 1,
        margin: 1,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        freeDrag: false,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        linked: navSlider.prev()
    }).on('initialized.owl.carousel linked.to.owl.carousel', function () {
        navSlider.find('.owl-item.current').removeClass('current');
        var current = navSlider.find('.owl-item.active.center').length ? navSlider.find('.owl-item.active.center') : navSlider.find('.owl-item.active').eq(0);
        current.addClass('current');
    });

    $(navSlider).owlCarousel({
        nav: true,
        dots: false,
        loop: true,
        center: true,
        items: slidesToShow,
        margin: 10,
        navText : ['<i class="fa fa-angle-left" aria-hidden="true"></i>','<i class="fa fa-angle-right" aria-hidden="true"></i>'],
        linked: ".product-slider",
        responsive:{
            0: {
                items: 2
            },
            576: {
                items: 2
            },
            768: {
                items: 3
            },
            992: {
                items: slidesToShow
            }
        }
    });

    $(navSlider).find('.owl-nav').removeClass('disabled');
    $(navSlider).on('changed.owl.carousel', function(event) {
        $(this).find('.owl-nav').removeClass('disabled');
    });

    $(headerSlider).owlCarousel({
        nav: true,
        dots: true,
        loop: true,
        items: 1,
        margin: 10,
        navText : ['<i class="fa fa-angle-left" aria-hidden="true"></i>','<i class="fa fa-angle-right" aria-hidden="true"></i>']
    });

});

/**
 * ScrollIt
 */
$(function () {
    $.scrollIt({
        scrollTime: 1100,
        easing: 'easeOutExpo',
        topOffset: -58,
        margin: 58
    })
});


/**
 * AOS
 */
AOS.init({
    startEvent: 'load',
    offset: 0,
    easing: 'ease-out-sine',
    once: true
})
window.addEventListener('load', function() {
    AOS.refreshHard()
    window.setTimeout(function () {
        AOS.refreshHard()
    }, 250)
})


/**
 * Bootstrap Carousel switch teaserimage
 */
$(function() {

    if(document.querySelector('.carousel-item.active .carousel-teaser')) {
        let teaserContent = document.querySelector('.carousel-item.active .carousel-teaser').innerHTML
        $('#carousel-teaser-container').html(teaserContent)
    }

    $('.carousel').on('slide.bs.carousel', function () {
        $('#carousel-teaser-container').removeClass('fadInRightBig').addClass('fadeOutRightBig')
    })

    $('.carousel').on('slid.bs.carousel', function () {
        if(document.querySelector('.carousel-item.active .carousel-teaser')) {
            let teaserContent = document.querySelector('.carousel-item.active .carousel-teaser').innerHTML
            $('#carousel-teaser-container').html(teaserContent)
            $('#carousel-teaser-container').removeClass('fadeOutRightBig').addClass('fadInRightBig')
        }
    })
})

/**
 * DataTables
 */
$(document).ready(function() {
    $('.job-table').DataTable({
        "paging":   false,
        "ordering": true,
        "info":     true,
        "language": {
            "url": "https://cdn.datatables.net/plug-ins/1.10.19/i18n/German.json"
        }
    })
})

/**
 * Station Detail Day highlight
 */
$(document).ready(function() {
    $('.opening-hours li').eq(new Date().getDay()).addClass('today');
});




// WEBPACK FOOTER //
// ./Private/_src/js/main.js